import React from "react";
import Field from "./Field";
import SelectListControl from "./SelectListControl";
import { SelectListFieldProps } from "./Types";

const SelectListField: React.FC<SelectListFieldProps> = ({ labelProps, controlProps, visible, disabled, options, optionsUrl, nullOption }) => {

    if (visible === false)
        return <></>;

    return (
        <Field {...labelProps}>
            <SelectListControl {...controlProps} disabled={disabled} options={options} optionsUrl={optionsUrl} nullOption={nullOption} />
        </Field>
    );
}
export default SelectListField;